import { EntityRepository, Repository } from "typeorm";
import { Columns } from "./colunms.entity";



@EntityRepository(Columns)
export class ColumnsRepository extends Repository<Columns>{

}
